<template>
    <div class="header">
        <div class="header__top">
            <v-container class="d-flex justify-space-between align-center" style="padding: 0">
                <logo :width="104" :height="24"/>

                <div class="d-flex align-center" v-if="currentName">
                    <div
                        class="header__top-user d-flex align-center"
                        @click="openSettingHandler"
                    >
                        <svg-icon name="user"/>
                        <div class="ml-3 mr-2" >
                            {{currentName}}
                        </div>
                        <svg-icon name="triangle" :class="isOpenSettings ? 'is-open' : ''"/>

                        <transition name="dropdown" mode="in-out">
                            <div v-if="isOpenSettings" class="header__top-user_setting">
                                <span class="d-flex align-center">
                                    <svg-icon name="lock" class="mr-2"/>
                                    <router-link
                                        :to="{ name: 'members-change-password' }"
                                        class="header__top-user_setting-link"
                                    >{{$t('landing.header.change_password')}}</router-link>
                                </span>
                            </div>
                        </transition>

                    </div>

                    <div class="header__top-logout" @click="logoutHandler">
                        <svg-icon name="exit" />
                    </div>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                isOpenSettings: false
            }
        },
        methods: {
            async logoutHandler() {
                await this.$store.dispatch('CLIENT_MAKE_LOGOUT')
                this.$router.push('/members/sign-in/')
            },

            openSettingHandler () {
                this.isOpenSettings = !this.isOpenSettings;
            }
        },
        computed: {
          getClient() {
            return this.$store.getters.getClient;
          },
          currentName() {
            if(!Object.keys(this.getClient).length) return null;
            const {first_name, last_name} = this.getClient;
            return `${first_name} ${last_name}`;
          }
        },
    }
</script>